import { createContext, useContext } from "react";

import { ChatBotSessionId } from "@fartherfinance/frontend/api/Chatbot/Types";

import { ChatState } from "../reducer/types";

// Create a context for analytics data
interface ChatAnalyticsContextType {
  sessionId: string | null;
  messageCount: number;
  getSessionId: () => string | null;
  getAnalyticsData: () => Partial<ChatState>;
  setAnalyticsData: (data: Partial<ChatState>) => void;
}

// Default implementation
const defaultContext: ChatAnalyticsContextType = {
  sessionId: null,
  messageCount: 0,
  getSessionId: () => null,
  getAnalyticsData: () => ({}),
  setAnalyticsData: () => {},
};

// Create global analytics data store (private to this module)
let analyticsData: Partial<ChatState> = {};

// Create the context
// eslint-disable-next-line import/no-unused-modules
export const ChatAnalyticsContext =
  createContext<ChatAnalyticsContextType>(defaultContext);

// Create a provider component wrapper (implemented in analyticsProvider.tsx)

// Create a hook for easy access to the analytics data
// eslint-disable-next-line import/no-unused-modules
export const useChatAnalytics = () => useContext(ChatAnalyticsContext);

// Export a simple module-level API for components that can't use context
export const ChatAnalytics = {
  getSessionId: (): ChatBotSessionId | null => {
    return analyticsData.sessionId || null;
  },

  getAnalyticsData: (): Partial<ChatState> => {
    return { ...analyticsData };
  },

  setAnalyticsData: (data: Partial<ChatState>): void => {
    analyticsData = { ...analyticsData, ...data };
  },

  clear: (): void => {
    analyticsData = {};
  },
};
